var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva-side-nav"},_vm._l((_vm.$ml.get('sections')),function(section,sectionIndex){return _c('div',{key:sectionIndex,class:[
      'tva-side-nav-item',
      {
        active: sectionIndex === _vm.index
      }
    ],on:{"click":function($event){_vm.selectedSection = _vm.index}}},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#' + section.section),expression:"'#' + section.section"}],attrs:{"href":'#' + section.section}},[_vm._v("\n      "+_vm._s(section.title)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }